
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/bookings",
      function () {
        return require("private-next-pages/account/bookings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/bookings"])
      });
    }
  